import * as React from "react";

export const AlpineWidget = ({ template }) => {
    return (
        <div dangerouslySetInnerHTML={{__html: template}} />
    );
};

export default AlpineWidget;